// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root___oGfh","title":"InfoRow_title__2ojoS"};